import { MY_REMINDERS_HEADING } from "../../components/reminder/reminderStaticContent";
import { ACCOUNT_MENU_ITEM_IDS } from "../myAccount/menu";
import { AccountRoutes } from "../myAccount/routes";

const desktopIcons = [
  {
    url: "/icons/desktop-reminder.svg",
    label: MY_REMINDERS_HEADING,
    width: 25,
    landingUrl: "/reminder",
    id: "myReminders",
  },
  { url: "/icons/currency-icons/inr.svg", label: "INR", width: 25, id: "currency" },
  {
    url: "/icons/corporate-gift.svg",
    label: "Corporate",
    width: 25,
    landingUrl: "/corporate/?promo=corporate_enquiry",
    id: "corporate",
  },
  { url: "/icons/cart.svg", label: "Cart", width: 25, id: "cart", landingUrl: "/checkout/delivery-address" },
  { url: "/icons/user-square-desktop.svg", label: "Hello Guest", width: 25, id: "account" },
  { url: "/icons/more.svg", label: "More", width: 25, id: "moreItems" },
];

const constantText = {
  toolbar: {
    currency: "Currency",
    account: "Account",
    more: "More",
    cart: "Cart",
  },
  MEDIA: "Media",
  LOGIN_REGISTER: "Login/Register",
  LOGOUT: "Logout",
  HELLO_GUEST: "Hello Guest",
  SIGNED_IN_AS: "Signed in as",
};

/** Desktop header account popover (My Accounts migration). Guests see login row first, then same items as logged-in; `/account` links open login. */
export const headerAccountDropdown = {
  guestLoginMenuItem: { menuId: "login-register", label: constantText.LOGIN_REGISTER, action: "login" },
  loggedInPrimary: [
    {
      menuId: ACCOUNT_MENU_ITEM_IDS.MY_ORDERS,
      label: "My orders",
      landingUrl: `/account/${AccountRoutes.MY_ORDERS}`,
    },
    {
      menuId: ACCOUNT_MENU_ITEM_IDS.FNP_CASH,
      label: "fnpCash",
      landingUrl: `/account/${AccountRoutes.WALLET_DETAILS}`,
      hideForSmartBuy: true,
    },
    {
      menuId: ACCOUNT_MENU_ITEM_IDS.MY_PROFILE,
      label: "My profile",
      landingUrl: `/account/${AccountRoutes.MY_PROFILE}`,
    },
    {
      menuId: ACCOUNT_MENU_ITEM_IDS.SAVED_ADDRESSES,
      label: "Saved addresses",
      landingUrl: `/account/${AccountRoutes.MY_ADDRESS_BOOK}`,
    },
  ],
  loggedInSupport: [
    { menuId: "contact-us", label: "Contact Us", landingUrl: "/info/contact-us" },
    { menuId: "faqs", label: "FAQs", landingUrl: "/info/faq" },
  ],
  loggedInFooter: [{ menuId: ACCOUNT_MENU_ITEM_IDS.LOGOUT, label: "Log out", action: "logout" }],
};
const mobileIconsHome = [
  { url: "/icons/currency-icons/inr.svg", label: "INR", width: 25, id: "currency" },
  { url: "/icons/cart.svg", label: "Cart", width: 25, id: "cart" },
];
const mobileIcons = [
  { url: "/icons/search-normal.svg", label: "Search", width: 25, id: "search" },
  // { url: "/icons/currency-icons/inr.svg", label: "INR", width: 25, id: "currency" },
  { url: "/icons/cart.svg", label: "Cart", width: 25, id: "cart" },
];
const mediaPopUp = {
  PLEASE_MAIL_TO: "Please mail to",
  FOR_QUERY: "for media queries",
  PR_EMAIL: "pr@fnp.com",
};
const SEND_GIFT_ABROAD = "Send Gifts Abroad";
const SHOP_BY_OCCASION = "Occasion";
const SHOP_BY_CATEGORY = "Category";
const GLOBAL = "Global";
const INTERNATIONAL = "International";
const OTHER_COUNTRIES = "other countries";
const NEW = "New";

export {
  constantText,
  desktopIcons,
  mobileIcons,
  mediaPopUp,
  mobileIconsHome,
  SEND_GIFT_ABROAD,
  SHOP_BY_OCCASION,
  SHOP_BY_CATEGORY,
  GLOBAL,
  INTERNATIONAL,
  OTHER_COUNTRIES,
  NEW,
};
